import { ApplicationStore } from '../states'

export const updateClientId: (state: ApplicationStore, payload: string) => ApplicationStore = (state, payload) => {
  return {
    ...state,
    clientId: payload,
  }
}

export const removeClientId: (state: ApplicationStore) => ApplicationStore = (state) => {
  const newState: ApplicationStore = JSON.parse(JSON.stringify(state))

  delete newState.clientId
  return {
    ...newState,
  }
}
